import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import { DeleteKeys, SNAPUP_UPDATE, UPDATE_QR_SETTING } from "../../../../../actions/appsMoreAction";
import { TOAST_DISMISS, TOAST_ERROR, TOAST_SUCCESS } from "../../../../../utils";
import CheckBoxField from "../../Feeds/AddFeeds/Elements/CheckboxField";
// import ColorPicker from "../../Studio/app/pages/apps/colorPicker";
import InputSlider from "../../Feeds/AddFeeds/Elements/InputSlider";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import withRouter from "../../../../CommonComponents/WithRouter";
import { Button } from "react-bootstrap";
import ColorPicker from "../../../../CommonComponents/ColorPicker";

const QrSetting = (props) => {
    const { UgcSettings, snapUpData, fonts, updateQrSetting, showDiscardPop, dispatch, activeSetting, backToSnapUp } = props;

    const [state, setState] = useState({
        onsite_button_status: UgcSettings?.onsite_status ? UgcSettings?.onsite_button_status : 0,
        onsite_overlay_poisition: UgcSettings?.onsite_overlay_poisition,
        onsite_qr_code_btn_text: UgcSettings?.onsite_qr_code_btn_text,
        onsite_btn_color: UgcSettings?.onsite_btn_color,
        onsite_btn_txt_color: UgcSettings?.onsite_btn_txt_color,
        onsite_txt_font_size: UgcSettings?.onsite_txt_font_size,
        onsite_overlay_height: UgcSettings?.onsite_overlay_height,
        fontStyleSelect: [],
        fontVarSelect: [],
        fontDefault: 0,
        fontVDefault: 0,
        qrPosition: [
            { label: "At Bottom Right", value: 1 },
            { label: "At Bottom Left", value: 2 },
            { label: "At Top Right", value: 3 },
            { label: "At Top Left", value: 4 },
        ],
        onsite_css_font_btn: '',
        onsite_font_varient_btn: '',
        spinner: false,
    });

    useEffect(() => {
        let fontStyleSelectData = [{ label: "Default", value: 0 }];
        let fontDefault = 0;

        fonts?.forEach((font, index) => {
            const isSelected = String(font.family).toLowerCase() === String(UgcSettings?.onsite_txt_font).toLowerCase();
            if (isSelected) {
                fontDefault = index + 1;
                onBtnFontChange({ label: <span style={{ fontFamily: font.family }}>{font.family}</span>, value: font.id, }, false);
            }
            fontStyleSelectData.push({ label: <span style={{ fontFamily: font.family }}>{font.family}</span>, value: font.id, });
        });

        setState((prevState) => ({ ...prevState, fontStyleSelect: fontStyleSelectData, fontDefault, }));
    }, []);

    useEffect(() => {
        if (snapUpData?.onsite_status !== undefined && snapUpData.onsite_status !== state.onsite_button_status) {
            if (snapUpData.onsite_status === 0) {
                setState((prevState) => ({ ...prevState, onsite_button_status: 0 }));
            }
        }
    }, [snapUpData]);

    const onBtnFontChange = useCallback((e, status) => {
        const selectedFont = fonts.find((font) => font.id === e.value);
        const variants = selectedFont
            ? JSON.parse(selectedFont.variants).map((variant, i) => ({
                label: <span key={variant} style={{ fontFamily: e.label.props.style.fontFamily }}>{variant}</span>,
                value: i,
                variant,
            }))
            : [{ label: "None", value: 0 }];

        const saved = UgcSettings?.onsite_txt_font_variation || UgcSettings?.onsite_font_varient_btn;
        const savedIndex = status ? -1 : variants.findIndex((v) => String(v.variant).toLowerCase() === String(saved).toLowerCase());
        const activeIndex = savedIndex > -1 ? savedIndex : 0;
        const activeVariant = variants[activeIndex]?.variant || '';

        setState((prevState) => ({ ...prevState, fontVarSelect: variants, onsite_css_font_btn: e?.label?.props?.style?.fontFamily, onsite_font_varient_btn: activeVariant, fontVDefault: activeIndex, }));
        if (status) updateQrSetting({ onsite_css_font_btn: e?.label?.props?.style?.fontFamily, onsite_txt_font: e?.label?.props?.style?.fontFamily, onsite_font_varient_btn: activeVariant, onsite_txt_font_variation: activeVariant });
    },
    );


    const onChangeVariant = useCallback((e) => {
        setState((prevState) => ({ ...prevState, fontVDefault: e.value }));
        setState((prevState) => ({ ...prevState, onsite_font_varient_btn: e.variant }));
        updateQrSetting({ onsite_font_varient_btn: e.variant, onsite_txt_font_variation: e.variant })
    })

    const onSubmitData = () => {
        const { onsite_button_status, onsite_overlay_poisition, onsite_qr_code_btn_text, onsite_btn_color, onsite_btn_txt_color, onsite_css_font_btn, onsite_overlay_height, onsite_txt_font_size, onsite_font_varient_btn, spinner } = state;

        const data = {
            wallId: localStorage.getItem("wallId"),
            onsite_button_status,
            onsite_overlay_poisition,
            onsite_qr_code_btn_text,
            onsite_btn_color,
            onsite_btn_txt_color,
            onsite_css_font_btn,
            onsite_overlay_height,
            onsite_txt_font_size,
            onsite_font_varient_btn,
        };

        setState((prevState) => ({ ...prevState, spinner: true }));
        UPDATE_QR_SETTING({ data }).then((res) => {
            const { data } = res;
            setState((prevState) => ({ ...prevState, spinner: false }));
            activeSetting(0);
            removeTab();

            if (data.responseCode === 200) {
                DeleteKeys();
                TOAST_DISMISS();
                TOAST_SUCCESS(data.responseData);
            } else {
                TOAST_DISMISS();
                TOAST_ERROR(data.responseData);
            }
        })
            .catch((error) => console.warn(error));
    }


    const applyChanges = (e, status) => {
        if (status == 0) removeTab();
        showDiscardPop(() => onSubmitData(e), 'snapup', status);
    }
    const removeTab = () => {
        const newUrl = window.location.href.replace(/\?tab=snapup[\/]?/, '')
        window.history.replaceState({}, '', newUrl)
    }

    const onChangeStatus = useCallback((value) => {
        console.log('first', snapUpData?.onsite_status)
        if (snapUpData?.onsite_status == 1 || (snapUpData?.onsite_status == undefined && UgcSettings?.onsite_status == 1)) {
            updateQrSetting({ onsite_button_status: value });
            setState((prevState) => ({ ...prevState, onsite_button_status: value }));
        } else {
            Swal.fire({
                title: "<strong>Update Status!</strong>",
                icon: "warning",
                text: "To complete this action, you need to activate SnapUp first.",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: true,
                confirmButtonText: "Turn On",
            }).then((result) => {
                if (result.value) {
                    dispatch(SNAPUP_UPDATE({ onsite_status: 1, wallId: localStorage.getItem("wallId"), network: 29, filter: 10 }, () => { setState((prevState) => ({ ...prevState, onsite_button_status: 1, onsite_status: 1 })); updateQrSetting({ onsite_button_status: 1, onsite_status: 1 }) }));
                }
            });
        }
    },
        [dispatch, snapUpData, updateQrSetting]
    );

    const { onsite_button_status, onsite_qr_code_btn_text, onsite_overlay_poisition, onsite_txt_font_size, onsite_overlay_height, onsite_btn_txt_color, onsite_btn_color, fontStyleSelect, fontVarSelect, fontDefault, fontVDefault, qrPosition, spinner } = state;

    return (
        <div className="qr-setings ">
            <div className="overflow-list">
                <div className="form-group">
                    <div className="d-flex flex-wrap w-100">
                        <div className="col-md-9">
                            {backToSnapUp ? <Link to={`/wall/snapup/${localStorage.getItem('wallId')}`} ><i className="fa fa-angle-left" aria-hidden="true"></i></Link> : ''}
                            <label className="card-label font-weight-bolder text-dark ms-2">QR Setting</label>
                        </div>
                        <div className="col-md-3 p-0">
                            <div className="toggleOnBut float-end">
                                <span className="switch">
                                    <label>
                                        <CheckBoxField isChecked={onsite_button_status} onChangeHandler={(e) => onChangeStatus(e.target.checked)} name={`transparent`} id={`walltransparent`} text={0} />
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label className="control-label mb-2">QR Position </label>
                    <Select defaultValue={qrPosition[onsite_overlay_poisition - 1]} options={qrPosition} onChange={(e) => { updateQrSetting({ onsite_overlay_poisition: e.value }); setState((prevState) => ({ ...prevState, onsite_overlay_poisition: e.value })) }} />
                </div>
                <div className="form-group">
                    <label className="control-label mb-2">QR Text </label>
                    <input className='form-control' value={onsite_qr_code_btn_text} onChange={(e) => { updateQrSetting({ onsite_qr_code_btn_text: e.target.value }); setState((prevState) => ({ ...prevState, onsite_qr_code_btn_text: e.target.value })) }} />
                </div>
                <div className="">
                    <div className="form-group color-popup onsite_overlay_poisition-relative position-relative">
                        <label className="control-label mb-2">Background Color</label>
                        <ColorPicker id={'qr-background'} changeColor={(clr) => { updateQrSetting({ onsite_btn_color: clr }); setState((prevState) => ({ ...prevState, onsite_btn_color: clr })) }} defaultColor={onsite_btn_color} />
                    </div>


                </div>
                <div className="form-group">
                    <label className="control-label mb-2">Font Family</label>
                    <div className="font-style mb-3">
                        {fontStyleSelect.length ? <Select options={fontStyleSelect} defaultValue={fontStyleSelect[fontDefault]} onChange={(e) => onBtnFontChange(e, true)} /> : null}
                    </div>
                    <label className="control-label mb-2">Font Weight</label>
                    <div className="font-style mb-3">
                        {fontStyleSelect.length ?
                            <Select id="fontDefault" options={fontVarSelect} value={fontVarSelect[fontVDefault]} onChange={(e) => { onChangeVariant(e) }} /> : null}
                    </div>
                </div>

                <div className="">
                    <div className="form-group color-popup onsite_overlay_poisition-relative position-relative">
                        <label className="control-label mb-2">Font Color</label>
                        <ColorPicker id="qr-font-color" changeColor={(clr) => { updateQrSetting({ onsite_btn_txt_color: clr, onsite_txt_color: clr }); setState((prevState) => ({ ...prevState, onsite_btn_txt_color: clr })) }} defaultColor={onsite_btn_txt_color} />

                    </div>
                </div>


                <div className="form-group">
                    <div className="align-items-center">
                        <div className="col-12"> <label className="d-flex justify-content-between" htmlFor="wallgetPersonalizefontSize" style={{ marginBottom: "0px" }}> Font Size <span><span className="datawallgetPersonalizefontSize" id="value-span">{onsite_txt_font_size}</span>px</span> </label>
                            <div className="pt-1 pe-3">
                                <InputSlider onChangeHandler={(event) => { updateQrSetting({ onsite_txt_font_size: parseInt(event) }); setState((prevState) => ({ ...prevState, onsite_txt_font_size: parseInt(event) })) }} isValue={onsite_txt_font_size} max={30} min={10} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="form-group">
                     <div className="align-items-center">
                         <div className="col-12"> <label className="d-flex justify-content-between" htmlFor="wallgetPersonalizefontSize" style={{ marginBottom: "0px" }}> Overlay Height <span><span className="datawallgetPersonalizefontSize" id="value-span">{onsite_overlay_height}</span>px</span> </label>
                             <div className="pt-1 pe-3">
                                 <InputSlider onChangeHandler={(event) => { updateQrSetting({ onsite_overlay_height: parseInt(event) }); setState((prevState) => ({ ...prevState, onsite_overlay_height: parseInt(event)  }))  }} isValue={onsite_overlay_height} max={250} min={100} />
                             </div>
                         </div>
                     </div>
                 </div> */}

            </div>
            <div className="form-actions px-3 pt-3">
                <div className="card-toolbar f-center">
                    <Button type="button" variant="secondary" className="w-50 me-2 position-relative" onClick={(e) => applyChanges(e, 0)}>
                        <span className="onsite_overlay_poisition-relative">Back</span>
                    </Button>

                    <Button type="submit" variant="dark" disabled={spinner} className={`commanBtn w-50 ${spinner ? `spinner spinner-white spinner-right disabled` : null}`} onClick={(e) => applyChanges(e, 1)}> Save </Button>
                </div>
            </div>

        </div>

    );
};

export default withRouter(QrSetting);